import { useQuery, useMutation, keepPreviousData } from '@tanstack/react-query';
import { FeeExportType } from 'further-types/fees';
import { api } from 'lib/httpClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

async function fetchFees({ queryKey }) {
  const [, { params }] = queryKey;

  const { data } = await api.post('fee/list', params);

  return data.data;
}

const exportFees = async (params) => {
  const response = await api.post(
    'fee/export',
    {
      ...params,
      exportType: FeeExportType.Custodian,
    },
    {
      responseType: 'blob',
    },
  );

  if (response.status !== 200) {
    throw Error('Unexpected export response.');
  }
  return response.data;
};

export function useFees({ params }) {
  const { mutateAsync, isPending: isExportLoading } = useMutation({
    mutationFn: () => exportFees(params),
  });

  return {
    fees: useQuery({
      queryKey: ['fees', { params }],
      queryFn: fetchFees,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME_MS,
    }),
    exportFees: mutateAsync,
    isExportLoading,
  };
}
